import { t } from "@redotech/redo-i18n";
import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import {
  productPropertyFromModel,
  validateProductPropertyCondition,
  type ProductPropertyState,
} from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const PRODUCT_PROPERTY = (
  Details: React.ComponentType<ConditionTypeDetailsProps<ProductPropertyState>>,
): ConditionType<ProductPropertyState, Condition.ProductProperty> => ({
  name: CONDITION_NAMES[Condition.PRODUCT_PROPERTY],
  description(state) {
    return t("Product properties: {{properties}}", {
      properties: state.join(", "),
    });
  },
  Details(props: ConditionTypeDetailsProps<ProductPropertyState>) {
    return React.createElement(Details, props);
  },
  empty: [],
  fromModel(model: Condition.ProductProperty) {
    return productPropertyFromModel(model);
  },
  toModel(state) {
    return { type: Condition.PRODUCT_PROPERTY, properties: state };
  },
  valid(state) {
    return validateProductPropertyCondition(state).valid;
  },
});
